/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../types.generated";
export type GenerateSponsorshipHackerRecruitmentCsvLinkMutationVariables =
  Types.Exact<{
    year: Types.Scalars["Float"];
  }>;

export type GenerateSponsorshipHackerRecruitmentCsvLinkMutation = {
  generateSponsorshipHackerRecruitmentCsvLink: Pick<
    Types.FileDownload,
    "uri" | "name" | "expiry"
  >;
};

export const GenerateSponsorshipHackerRecruitmentCsvLinkDocument = gql`
  mutation GenerateSponsorshipHackerRecruitmentCsvLink($year: Float!) {
    generateSponsorshipHackerRecruitmentCsvLink(year: $year) {
      uri
      name
      expiry
    }
  }
`;

/**
 * __useGenerateSponsorshipHackerRecruitmentCsvLinkMutation__
 *
 * To run a mutation, you first call `useGenerateSponsorshipHackerRecruitmentCsvLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSponsorshipHackerRecruitmentCsvLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSponsorshipHackerRecruitmentCsvLinkMutation, { data, loading, error }] = useGenerateSponsorshipHackerRecruitmentCsvLinkMutation({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGenerateSponsorshipHackerRecruitmentCsvLinkMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    GenerateSponsorshipHackerRecruitmentCsvLinkMutation,
    GenerateSponsorshipHackerRecruitmentCsvLinkMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    GenerateSponsorshipHackerRecruitmentCsvLinkMutation,
    GenerateSponsorshipHackerRecruitmentCsvLinkMutationVariables
  >(GenerateSponsorshipHackerRecruitmentCsvLinkDocument, baseOptions);
}
export type GenerateSponsorshipHackerRecruitmentCsvLinkMutationHookResult =
  ReturnType<typeof useGenerateSponsorshipHackerRecruitmentCsvLinkMutation>;
export type GenerateSponsorshipHackerRecruitmentCsvLinkMutationResult =
  ApolloReactCommon.MutationResult<GenerateSponsorshipHackerRecruitmentCsvLinkMutation>;
export type GenerateSponsorshipHackerRecruitmentCsvLinkMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    GenerateSponsorshipHackerRecruitmentCsvLinkMutation,
    GenerateSponsorshipHackerRecruitmentCsvLinkMutationVariables
  >;
